let USER_POOL_ID = 'ap-northeast-2_mFkRRvlLv'
let USER_POOL_CLIENT_ID = '48525rlfdr97d539vobmq3d58p'

export {USER_POOL_ID, USER_POOL_CLIENT_ID}
